import { Route, Routes } from "react-router-dom";
import PaymentAccountCreateScreen from "screens/App/CRM/Payment/PaymentAccount/PaymentAccountCreateScreen";
import PaymentAccountDetailScreen from "screens/App/CRM/Payment/PaymentAccount/PaymentAccountDetailScreen";
import PaymentAccountEditScreen from "screens/App/CRM/Payment/PaymentAccount/PaymentAccountEditScreen";
import PaymentAccountListScreen from "screens/App/CRM/Payment/PaymentAccount/PaymentAccountListScreen";

const AdjustmentRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<PaymentAccountListScreen />} />
      <Route path="create" element={<PaymentAccountCreateScreen />} />
      <Route path=":id/detail" element={<PaymentAccountDetailScreen />} />
      <Route path=":id/edit" element={<PaymentAccountEditScreen />} />
    </Routes>
  );
};

export default AdjustmentRouter;
